import Vue from 'vue';
import store from '@/store/';
import {
  SAVE_COUNTER_SHOPPINGCART,
} from '@/store/mutation-types';

export default function Initializer() {
  store.commit('shoppingCart/SET_SHOPPING_CART_INIT', Vue.ls.get(SAVE_COUNTER_SHOPPINGCART));
}



// WEBPACK FOOTER //
// ./src/core/bootstrap.js